module.exports = __webpack_public_path__ + "static/media/klarna_logo.afb80552.svg";